// Lines an info step fills instead of approving (at Teatrul de Stat Constanța: the commitment
// code and sum, written after the director general's approval).

const plain = (text) =>
  String(text || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

/** A line named "Sumă" (or "Suma ...") starts with the paper's total with VAT. */
export const isSumLabel = (label) => /^suma?\b/.test(plain(label));

/** Total with VAT of the articles shown in the paper, as the modal computes it. */
export const totalWithVat = (articles) => {
  let total = 0;
  (articles || []).forEach((article) => {
    const noVat = article.quantity * article.pricePerUnit;
    total += (noVat * article.vat) / 100 + noVat;
  });
  return Math.round(total * 100) / 100;
};

/** Starting value of a line: the total for the sum, empty otherwise. */
export const defaultInfoValue = (label, articles) => {
  if (!isSumLabel(label)) {
    return "";
  }
  const total = totalWithVat(articles);
  return Number.isFinite(total) && total > 0 ? total.toFixed(2) : "";
};

/** The lines filled so far, in route order: [{ order, calling, lines: [{label, value}] }]. */
export const recordedInfoLines = (approvals) =>
  (approvals || [])
    .filter((approval) => approval && (approval.infoLines || []).length > 0)
    .sort((a, b) => a.orderNumber - b.orderNumber)
    .map((approval) => ({ order: approval.orderNumber, calling: approval.calling, lines: approval.infoLines }));

export const INFO_VALUE_MAX_LENGTH = 128;
